export const APP_BASE = "/kfowebsdk" ;
export const API_BASE  = APP_BASE + "/api" ;


//STB
//export const OMCC_SECURE_URL  = "https://omccstb.turkcell.com.tr/paymentmanagement/rest/threeDSecure" ;
//export const GET_TOKEN_URL  = "https://omccstb.turkcell.com.tr/paymentmanagement/rest/token" ;


//export const OMCC_SECURE_URL  = "https://epayment.turkcell.com.tr/paymentmanagement/rest/threeDSecure";
//export const GET_TOKEN_URL  = "https://epayment.turkcell.com.tr/paymentmanagement/rest/token";